import { APP_BASE_HREF, CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { ApContentModule } from '@ap/content';
import { ApPegaModule } from '@ap/pega';

// @ts-ignore: Needs to be ignored so the typescript compiler replaces BASE_HREF
export const baseHref: string = BASE_HREF;

@NgModule({
    imports: [ApContentModule, ApPegaModule, BrowserModule, CommonModule],
    providers: [
        {
            provide: APP_BASE_HREF,
            useValue: baseHref
        },
        Location,
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        }
    ]
})
export class ProductOpenenModule {}
